<section class="col-seleccion enLocalizador enEspectaculos">
  <div class="tituloInt tituloEspectaculos">{{ 'ESPECTACULOS' | translate }}</div>
  <ticketing-lista-espectaculos></ticketing-lista-espectaculos>
</section>
<!-- <ticketing-resumen-compra></ticketing-resumen-compra> -->
